<template>
  <v-app style="height: 100%;" class="bg-primary">
    <v-main>
      <v-alert dense color="primary text-error" class="text-center pa-2" v-if="!!$store.state.info.top_banner && $store.state.info.top_banner.length > 2">
        {{ $store.state.info.top_banner }}
      </v-alert>
      
      <!-- <router-view/> -->
      <SplashPage v-if="$store.state.activePage == 'splash'"/>
      <BookingPage v-else-if="$store.state.activePage == 'booking'"/>
      <OrderPage v-else-if="$store.state.activePage == 'order'"/>
      <OrdersPage v-else-if="$store.state.activePage == 'orders_history'"/>
      <OrderDetailPage v-else-if="$store.state.activePage == 'order_detail'"/>
      <div v-else></div>
    </v-main>
    <Auth  v-if="$store.state.loginDialogStatus"/>
    <SubmitBookingPage  v-if="$store.state.bookingDialogStatus"/>
    <BookingSelectEmploye  v-if="$store.state.bookingSelectEmployeDialogStatus"/>

    
    <BookingSelectService  v-if="$store.state.bookingSelectServiceDialogStatus"/>

    <CartComponent v-if="$store.state.showCartDialogStatus"/>
  </v-app>
</template>

<script>

import SubmitBookingPage from './components/submit_booking.vue';
import BookingSelectEmploye from './components/booking_select_employe.vue';


import CartComponent from './components/cart.vue';
import BookingPage from './pages/booking.vue';
import OrderPage from './pages/order.vue';
import OrderDetailPage from './pages/order_detail.vue';
import OrdersPage from './pages/orders.vue';
import SplashPage from './pages/splash.vue';
import BookingSelectService from './components/booking_select_service.vue';
import Auth from './components/auth.vue';
export default {
  name: 'App',


  components: {
    Auth,
    SubmitBookingPage,
    BookingSelectEmploye,
    BookingSelectService,
    BookingPage,
    OrderPage,
    OrdersPage,
    OrderDetailPage,
    SplashPage,
    CartComponent,
  },

  data: () => ({
    
  }),
  methods: {
  },
  async mounted() {
    await this.$store.dispatch('fetchAuthToken');
    await this.$store.dispatch('fetchBaseData');

    if(this.$route.query.table){
      this.$store.commit('setTableNumber', this.$route.query.table);
    }
  },
 
}
</script>

<style>
.Vue-Toastification__toast-body{
  font-family: 'iransans' !important;
  direction: rtl;
}

.main-bg-color{
  background: linear-gradient(135deg, #ffffff, rgb(233, 230, 233));
}

.global-card-background {
  background-color: rgba(255, 255, 255, 0.2);
}
</style>
